var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0705 18.6708C37.0705 28.6827 28.954 36.8083 18.933 36.8083C8.91197 36.8083 0.79541 28.6827 0.79541 18.6708C0.79541 8.64976 8.91197 0.533203 18.933 0.533203C28.954 0.533203 37.0705 8.64976 37.0705 18.6708Z",
    fill: "#283544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.434 14.0811C27.3351 14.1389 24.9789 15.3574 24.9789 18.059C25.09 21.1401 27.9522 22.2207 28.0013 22.2207C27.9522 22.2784 27.5692 23.6926 26.4346 25.175C25.5342 26.452 24.5347 27.7395 23.0171 27.7395C21.5735 27.7395 21.0553 26.8884 19.3896 26.8884C17.6008 26.8884 17.0946 27.7395 15.7251 27.7395C14.2074 27.7395 13.134 26.383 12.1844 25.1181C10.9509 23.4624 9.90235 20.8642 9.86533 18.3695C9.84039 17.0475 10.1124 15.748 10.8028 14.6443C11.7773 13.1033 13.517 12.0573 15.4169 12.0228C16.8725 11.9771 18.1681 12.9541 19.0564 12.9541C19.9078 12.9541 21.4995 12.0228 23.3004 12.0228C24.0777 12.0236 26.1506 12.2418 27.434 14.0811ZM18.9333 11.7589C18.6742 10.5516 19.3896 9.34437 20.0559 8.57429C20.9072 7.64298 22.2519 7.01086 23.4114 7.01086C23.4854 8.21811 23.0163 9.40211 22.1778 10.2644C21.4254 11.1957 20.1299 11.8968 18.9333 11.7589Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleicon);
export default __webpack_public_path__ + "static/media/appleicon.a462c149fc5f13140294142fd4177c18.svg";
export { ForwardRef as ReactComponent };